import type { Theme } from '../../model'

export const defaultTheme: Theme = {
  colors: {
    // основная тема
    primary: '#FF4342',
    secondary: '#2D2727',
    error: '#FF4342',
    success: '#70A139',
    dark: '#000',
    light: '#fff',

    text: {
      main: '#2D2727',
      primary: '#FF4342',
      secondary: '#77787C',
      tertiary: '#BDBDBD',
      quaternary: '#053697',
      light: '#fff'
    },

    calendar: {
      text: {
        inactive: '#BDBDBD',
        primary: '#2D2727',
        weekend: '#FF4342',
        active: '#2D2727'
      }
    },

    button: {
      primary: {
        DEFAULT: '#FFFFFF',
        hover: '#FFFFFF',
        active: '#FFFFFF',
        focus: '#FFFFFF',
        disabled: '#BDBDBD'
      },
      secondary: {
        DEFAULT: '#FFFFFF',
        hover: '#FFFFFF',
        active: '#FFFFFF',
        focus: '#FFFFFF',
        disabled: '#BDBDBD'
      },
      tertiary: {
        DEFAULT: '#2D2727',
        hover: '#2D2727',
        active: '#2D2727',
        focus: '#2D2727',
        disabled: '#BDBDBD'
      },
      quaternary: {
        DEFAULT: '#2D2727',
        hover: '#2D2727',
        active: '#2D2727',
        focus: '#2D2727',
        disabled: '#BDBDBD'
      },
      link: {
        primary: {
          DEFAULT: '#2D2727',
          hover: '#2D2727',
          active: '#2D2727',
          focus: '#2D2727',
          disabled: '#BDBDBD'
        }
      },
      text: {
        DEFAULT: '#1B65F5',
        hover: '#053697',
        active: '#233353',
        focus: '#053697',
        disabled: '#C1C7D1'
      }
    },

    input: {
      primary: {
        DEFAULT: '#2D2727',
        hover: '#77787C',
        focus: '#2D2727',
        disabled: '#BDBDBD'
      }
    },

    checkbox: {
      icon: '#2D2727'
    },

    icon: {
      primary: '#2D2727',
      secondary: '#233353',
      tertiary: '#A1A8B5',
      disabled: '#C1C7D1',
      error: '#FF4342',
      success: '#70A139',
      light: '#fff'
    },

    badge: {
      primary: {
        DEFAULT: '#2D2727'
      }
    },

    gradient: {
      primary: {
        first: {
          color: 'rgba(0,0,0,0)',
          stop: '0%'
        },
        second: {
          color: 'rgba(0,0,0,0.9)',
          stop: '100%'
        }
      },
      secondary: {
        first: {
          color: 'rgba(0,0,0,0)',
          stop: '0%'
        },
        second: {
          color: 'rgba(0,0,0,0.5)',
          stop: '100%'
        }
      },
      tertiary: {
        first: {
          color: 'rgba(255,255,255,0)',
          stop: '0%'
        },
        second: {
          color: 'rgba(255,255,255,0.7)',
          stop: '50%'
        },
        third: {
          color: 'rgba(255,255,255,1)',
          stop: '100%'
        }
      }
    }
  },
  background: {
    'gradient-primary': 'var(--gradient-primary)',
    'gradient-secondary': 'var(--gradient-secondary)',
    'gradient-tertiary': 'var(--gradient-tertiary)',
    main: '#2D2727',
    primary: '#FFF',
    secondary: '#E8ECEF',
    overlay: 'rgba(0,0,0,0.3)',
    error: '#FF4342',
    success: '#70A139',
    dark: '#000',
    light: '#fff',

    button: {
      primary: {
        DEFAULT: '#FF4342',
        hover: '#FF4342',
        active: '#FF4342',
        focus: '#FF4342',
        disabled: '#fff',
        loading: '#fff'
      },
      secondary: {
        DEFAULT: '#2D2727',
        hover: '#2D2727',
        active: '#2D2727',
        focus: '#2D2727',
        disabled: '#fff',
        loading: '#fff'
      },
      tertiary: {
        DEFAULT: '#fff',
        hover: '#fff',
        active: '#fff',
        focus: '#fff',
        disabled: '#E8ECEF',
        loading: '#fff'
      },
      quaternary: {
        DEFAULT: '#fff',
        hover: '#E8ECEF',
        active: '#fff',
        focus: '#fff',
        disabled: '#fff',
        loading: '#fff'
      },
      link: {
        primary: {
          DEFAULT: 'transparent',
          hover: 'transparent',
          active: 'transparent',
          focus: 'transparent',
          disabled: 'transparent'
        },
        secondary: {
          DEFAULT: 'transparent',
          hover: 'transparent',
          active: 'transparent',
          focus: 'transparent',
          disabled: 'transparent'
        }
      },
      text: {
        DEFAULT: 'transparent',
        hover: 'transparent',
        active: 'transparent',
        focus: 'transparent',
        disabled: 'transparent'
      },
      icon: {
        DEFAULT: '#FFF',
        hover: '#F2F5FF',
        active: '#FFF',
        focus: '#F2F5FF',
        disabled: '#F2F2F2'
      }
    },

    input: {
      primary: {
        DEFAULT: '#FFF',
        hover: '#FFF',
        focus: '#FFF',
        disabled: '#E8ECEF'
      }
    },

    badge: {
      primary: {
        DEFAULT: '#FFFFFF'
      }
    },
    checkbox: {
      DEFAULT: '#2D2727',
      disabled: '#D8D8D8'
    },
    calendar: {
      range: '#E8ECEF',
      active: '#2D2727'
    },
    alert: {
      success: '#ddffe9',
      error: '#FFE7E6'
    },
    sliderBullet: {
      DEFAULT: '#D8D8D8',
      active: '#FF4342'
    }
  },
  borderColor: {
    primary: '#D8D8D8',
    secondary: '#77787C',
    tertiary: '#2D2727',
    quaternary: '#5a7eff',
    fivefold: '#E8ECEF',
    error: '#FF4342',
    success: '#70A139',
    dark: '#000',
    light: '#fff',

    checkbox: {
      DEFAULT: '#DDDDDD',
      hover: '#233353',
      checked: 'transparent',
      disabled: '#727985'
    },
    alert: {
      success: '#ddffe9',
      error: '#FFE7E6'
    },

    button: {
      primary: {
        DEFAULT: '#FF4342',
        hover: '#FF4342',
        active: '#FF4342',
        focus: '#FF4342',
        disabled: '#fff',
        loading: '#fff'
      },
      secondary: {
        DEFAULT: '#2D2727',
        hover: '#2D2727',
        active: '#2D2727',
        focus: '#2D2727',
        disabled: '#fff',
        loading: '#fff'
      },
      tertiary: {
        DEFAULT: '#D8D8D8',
        hover: '#2D2727',
        active: '#2D2727',
        focus: '#5A7EFF',
        disabled: '#E8ECEF',
        loading: '#fff'
      },
      quaternary: {
        DEFAULT: 'transparent',
        hover: '#E8ECEF',
        active: 'transparent',
        focus: '#5A7EFF',
        disabled: 'transparent',
        loading: 'transparent'
      },
      link: {
        primary: {
          DEFAULT: 'transparent',
          hover: 'transparent',
          active: 'transparent',
          focus: 'transparent',
          disabled: 'transparent'
        }
      },
      text: {
        DEFAULT: 'transparent',
        hover: 'transparent',
        active: 'transparent',
        focus: 'transparent',
        disabled: 'transparent'
      },
      icon: {
        DEFAULT: '#EFF3F8',
        hover: '#F2F5FF',
        active: '#EFF3F8',
        focus: '#F2F5FF',
        disabled: '#F2F2F2'
      }
    },

    input: {
      primary: {
        DEFAULT: '#D8D8D8',
        hover: '#2D2727',
        focus: '#5A7EFF',
        disabled: '#E8ECEF'
      }
    }
  },
  boxShadow: {
    primary: '0 8px 20px 0px rgba(78,78,78,0.12)'
  },
  fontFamily: {
    main: 'Inter'
  }
}
